
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../Helper/ToastMessage";


// Get Table Data
export const STPQualityTableDataAPI = createAsyncThunk("STPQualityTableData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        M_UserID,
        token,
        ReportType,
        STPQualityExport
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_STP_T_STP_SewerageQualityAll_Select?M_WardID=${M_WardID}&FromDate=${FromDate}&ToDate=${ToDate}&ReportType=${ReportType}&M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            // console.log(result.data1, result.data) 
            if (result.code >= 200 && result.code <= 300 && result.data && result.data.table) {
                STPQualityExport && STPQualityExport()
                return result.data.table

            } else {
                return result
            }
        })
})

const STPQualityTableDataSlice = createSlice({
    name: "STPQualityTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPQualityTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(STPQualityTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(STPQualityTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const STPQualityTableDataReducer = STPQualityTableDataSlice.reducer

// Export Data

export const STPQualityTableExportDataAPI = createAsyncThunk("STPQualityTableExportData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        M_UserID,
        token,
        ReportType
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_STP_T_STP_SewerageQualityAll_Select?M_WardID=${M_WardID}&FromDate=${FromDate}&ToDate=${ToDate}&ReportType=${ReportType}&M_UserID=${M_UserID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            // console.log(result.data1, result.data) 
            if (result.code >= 200 && result.code <= 300 && result.data && result.data.table) {
                return result.data.table

            } else {
                return result
            }
        })
})

const STPQualityTableExportDataSlice = createSlice({
    name: "STPQualityTableExportData",
    initialState: {
        isExportLoading: false,
        ExportTableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPQualityTableExportDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(STPQualityTableExportDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ExportTableData = action.payload;
        });
        builder.addCase(STPQualityTableExportDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ExportTableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const STPQualityTableExportDataReducer = STPQualityTableExportDataSlice.reducer



// -----------------Delete API ---------------

export const STPQualityDeleteAPI = createAsyncThunk("STPQualityDelete", async ({ data }) => {
    const {
        T_STP_SewerageQuality_BID,
        M_UserID,
        token,
        handleIsPost
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);


    var formdata = new FormData();
    formdata.append("T_STP_SewerageQuality_BID", T_STP_SewerageQuality_BID);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/APKDashboard/WEB_STP_T_STP_SewerageQuality_B_Delete`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)

            }
            return result

        })
})

const STPQualityDeleteSlice = createSlice({
    name: "STPQualityDelete",
    initialState: {
        isDeleteLoading: false,
        SectorData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPQualityDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(STPQualityDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.SectorData = action.payload;

        });
        builder.addCase(STPQualityDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.SectorData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const STPQualityDeleteReducer = STPQualityDeleteSlice.reducer